import React, { useEffect, useState } from 'react';
import axiosInstance from '../utils/axiosConfig';

/**
 * Single-select for a student's rank, sourced from db.ranks (Manage Ranks)
 * instead of a hardcoded PharmD/SPEP list. "Alumni" is not a rank — it is a
 * separate graduation status tracked elsewhere — but is offered here too since
 * this dropdown has historically doubled as the place to set it.
 */
const RankSelect = ({ value, onChange, required = false, includeAlumni = true, disabled = false }) => {
  const [ranks, setRanks] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    axiosInstance.get('/ranks/ranks')
      .then((res) => { if (!cancelled) setRanks(Array.isArray(res.data) ? res.data : []); })
      .catch((err) => console.error('Failed to load ranks:', err))
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  return (
    <select value={value} onChange={onChange} required={required} disabled={disabled || loading}>
      <option value="">{loading ? 'Loading ranks...' : 'Select rank'}</option>
      {ranks.map((rank) => (
        <option key={rank._id} value={rank.name}>{rank.name}</option>
      ))}
      {includeAlumni && <option value="alumni">Alumni</option>}
    </select>
  );
};

export default RankSelect;
